import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { ActionsCell } from './cells/ActionsCell';
import { NameCell } from './cells/NameCell';
import { PermissionsCell } from './cells/PermissionsCell';
import { StatusCell } from './cells/StatusCell';
import styles from './UsersTable.module.css';
import { TIntroducerListItem } from './UsersTable.types';

const columnHelper = createColumnHelper<TIntroducerListItem>();

const columns = [
  columnHelper.display({
    id: 'name',
    header: 'Name',
    size: 240,
    cell: ({ row }) => <NameCell user={row.original} />,
  }),
  columnHelper.accessor('is_active', {
    id: 'status',
    header: 'Status',
    size: 120,
    cell: (info) => <StatusCell isActive={info.getValue()} />,
  }),
  columnHelper.accessor('permissions', {
    id: 'permissions',
    header: 'Account permissions',
    size: 360,
    cell: (info) => <PermissionsCell permissions={info.getValue()} />,
  }),
  columnHelper.accessor('email', {
    id: 'email',
    header: 'Email',
    size: 280,
    cell: (info) => info.getValue() ?? '',
  }),
  columnHelper.accessor('phone_number', {
    id: 'phone',
    header: 'Phone',
    size: 160,
    cell: (info) => info.getValue(),
  }),
  columnHelper.display({
    id: 'actions',
    header: '',
    size: 56,
    cell: () => <ActionsCell />,
  }),
];

type TProps = { users: TIntroducerListItem[] };

export const UsersTable = ({ users }: TProps) => {
  const table = useReactTable({
    data: users,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <colgroup>
          {table.getHeaderGroups()[0].headers.map((header) => (
            <col key={header.id} style={{ width: header.getSize() }} />
          ))}
        </colgroup>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id} className={styles.header}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id} className={styles.row}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className={styles.cell}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
